import React from 'react';
export default function ComeOnLogoBlack(props) {
    return (
        <svg x="0px" y="0px" viewBox="0 0 453.5 75.9" enableBackground="0 0 453.5 75.9" {...props}>
            <path
                fill="#282B33"
                d="M32.2,26c6.2,0,11.6,3.3,14.7,8.2l8.4-13.3c-5.8-6-14-9.8-23.1-9.8C14.4,11.1,0,25.6,0,43.3
	s14.4,32.2,32.2,32.2c8.9,0,17-3.6,22.8-9.5l-8.4-13.2c-3.1,4.7-8.4,7.8-14.4,7.8c-9.5,0-17.3-7.7-17.3-17.3S22.6,26,32.2,26z"
            />
            <path
                fill="#8EB50D"
                d="M398.5,11.1c-15.7,0-28.4,11.5-28.4,27.2v35.4h16.1V38.9c0-6.8,5.5-12.4,12.4-12.4c6.8,0,12.4,5.6,12.4,12.4
	v34.8h16.1V38.3C426.9,22.7,414.2,11.1,398.5,11.1z"
            />
            <path
                fill="#282B33"
                d="M91.9,11.1c-10.3,0-19.5,4.9-25.4,12.5c-1.8,2.3-3.3,4.9-4.4,7.6c-1.5,3.7-2.3,7.8-2.3,12s0.8,8.3,2.3,12
	c1.1,2.7,2.6,5.3,4.4,7.6c5.9,7.6,15.1,12.5,25.5,12.5c17.7,0,32.2-14.4,32.2-32.2S109.6,11.1,91.9,11.1z M91.9,60.5
	c-4.7,0-8.9-1.9-12-4.9c-3.2-3.1-5.2-7.5-5.2-12.3c0-4.8,1.9-9.1,5.1-12.2C82.8,28,87.1,26,91.9,26c9.5,0,17.3,7.7,17.3,17.3
	S101.4,60.5,91.9,60.5z"
            />
            <path
                fill="#8EB50D"
                d="M328.5,11.1c-17.7,0-32.2,14.4-32.2,32.2s14.4,32.2,32.2,32.2c17.7,0,32.2-14.4,32.2-32.2
	S346.2,11.1,328.5,11.1z M328.5,60.5c-9.5,0-17.3-7.7-17.3-17.3S319,26,328.5,26s17.3,7.7,17.3,17.3S338,60.5,328.5,60.5z"
            />
            <path
                fill="#282B33"
                d="M287.5,39c-0.7-8.1-4.1-15.1-9.8-20.3c-5.5-4.9-12.9-7.6-20.7-7.6c-8.4,0-16.1,3.3-21.9,9.2
	c-5.9,6.1-9.1,14.3-9.1,23.3c0,9.4,3.4,17.5,9.8,23.3c5.9,5.4,14,8.4,22.7,8.4c10.8,0,19.6-3.7,26.1-11l-10.5-9.3
	c-3.8,4.2-9.1,6.3-15.5,6.3c-4,0-8-1.2-11.2-3.3c-3.4-2.2-5.7-5.3-6.8-8.9l-0.1-0.4l46.9,0C287.3,48.9,288,44.6,287.5,39z M257,24.6
	c4.4,0,8.4,1.5,11.4,4.3c2.4,2.3,4.2,5.4,5,8.8h-33C241.8,31.2,247.8,24.6,257,24.6z"
            />
            <path
                fill="#282B33"
                d="M191.9,11.5c-6.5,0-12.4,2.5-16.8,6.7c-4.4-4.2-10.3-6.7-16.8-6.7c-13.5,0-24.4,10.9-24.4,24.4v37.7h15.3V59.8
	V36v0h0c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2h0v0v23.9v13.8h15.3V59.8V36v0h0c0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2h0v0
	v23.9v13.8h15.3V36C216.3,22.5,205.4,11.5,191.9,11.5z"
            />
            <g>
                <rect x="438.5" y="59.7" fill="#8EB50D" width="15" height="14" />
                <polygon fill="#8EB50D" points="453.1,49.7 439,49.7 438.6,0 453.5,0 	" />
            </g>
        </svg>
    );
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/svg/comeon_black.js
 **/